<template>
    <content-dashboard :hide="true">
        <v-card>
            <v-card-title class="subtitle-1">Filtros</v-card-title>
            <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                    <v-col cols="12" xs="12" md="6" sm="6">
                        <v-text-field
                            dense
                            type="date"
                            label="Data Infração (Início)"
                            v-model="filtro.data_inicial"
                            outlined
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" md="6" sm="6">
                        <v-text-field
                            dense
                            type="date"
                            label="Data Infração (Fim)"
                            v-model="filtro.data_final"
                            outlined
                        ></v-text-field>
                    </v-col>

                </v-row>
            </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" @click="load(1, filtro)">Pesquisar</v-btn>
                <v-btn color="primary" outlined class="ml-5" @click="reset">Limpar</v-btn>
                <v-btn color="primary" class="ml-5" @click="downloadXLSX(filtro)">Exportar Dados</v-btn>
            </v-card-actions>
        </v-card>

        <v-divider class="my-2 mb-10 mt-10"></v-divider>

        <v-card>
            <v-card-title class="subtitle-1">Autos Status</v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Placa</th>
                                <th class="text-left">Tipo de Veículo</th>
                                <th class="text-left">Enquadramento</th>
                                <th class="text-left">Descrição</th>
                                <th class="text-left">Quantidade de Autos</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, key) in items" :key="key">
                                <td>{{ item.veiculo_placa   || "-" }}</td>
                                <td>{{ item.veiculo_tipo  || "-" }}</td>
                                <td>{{ `${item.codigo}-${item.digito}` || "-" }}</td>
                                <td>{{ item.descricao || "-" }}</td>
                                <td>{{ item.quantidade || "-" }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-pagination
                    color="primary"
                    v-model="currentData.current_page"
                    :length="currentData.last_page"
                    :total-visible="10"
                    @input="load($event, filtro)"
                ></v-pagination>
            </v-card-actions>
        </v-card>
    </content-dashboard>
</template>

<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";
import queryString from "querystring";
import downloadXLSXBlob from "../../utils/downloadXLSXBlob";

export default {
    name: "RankingMultasPlaca",
    data() {
        return {
            loading: false,
            valid: true,
            rules: [v => !!v || "Este campo é Obrigatório"],
            filtro: {},
            items: [],
            currentData: []
        };
    },

    created() {
        //this.load();
    },

    methods: {
        load(page = 1, filtro) {
            this.$store.commit("overlay/toggle", true);
            
            const filter = queryString.stringify(filtro);

            const url = `${urlApi}/relatorio/ranking-multas-por-placas?page=${page}&${filter}`;

            this.$http.get(url).then(res => {
                const response = res.data.data;

                this.items = response.data;
                this.currentData = response;

                this.$store.commit("overlay/toggle", false);
            }).catch((error) => {
                let erro = error.body.data;
        
                showError(`Ops, ${erro}`);

                this.$store.commit("overlay/toggle", false);
            });
        },

        downloadXLSX(filtro, exportar = true) {
            this.$store.commit("overlay/toggle", true);
            
            const filter = queryString.stringify(filtro);

            const url = `${urlApi}/relatorio/ranking-multas-por-placas?exportar=${exportar}&${filter}`;

            this.$http.get(url, { responseType: 'blob' }).then(response => {
                downloadXLSXBlob(response, 'ranking-multas-por-placas.xlsx');

                this.$store.commit("overlay/toggle", false);
            }).catch((error) => {
                let erro = error.body.data;
        
                showError(`Ops, ${erro}`);

                this.$store.commit("overlay/toggle", false);
            });
        },

        reset() {
            this.filtro = {};
        },
    }
};
</script>